import React from 'react';
import { ToolbarButton } from '@mui/x-data-grid-pro';
import Tooltip from '@mui/material/Tooltip';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from '@mui/material/CircularProgress';

const BulkApproveButton = ({ onClick, disabled, isApproving, bulkApproveMode, setBulkApproveMode }) => {
  // Parent controls confirm mode via bulkApproveMode
  const handleApproveClick = () => setBulkApproveMode(true);
  const handleCancel = () => setBulkApproveMode(false);
  const handleSubmit = async () => {
    await onClick();
    setBulkApproveMode(false);
  };

  if (bulkApproveMode) {
    return (
      <>
        <Tooltip title="Cancel">
          <ToolbarButton onClick={handleCancel} disabled={isApproving}>
            <CancelIcon fontSize="small" />
          </ToolbarButton>
        </Tooltip>
        <Tooltip title={isApproving ? 'Approving...' : 'Submit Approvals'}>
          <ToolbarButton onClick={handleSubmit} disabled={disabled}>
            {isApproving ? <CircularProgress size={16} /> : <DoneAllIcon fontSize="small" />}
          </ToolbarButton>
        </Tooltip>
      </>
    );
  }
  return (
    <Tooltip title="Approve">
      <ToolbarButton onClick={handleApproveClick}>
        <DoneAllIcon fontSize="small" />
      </ToolbarButton>
    </Tooltip>
  );
};

export default BulkApproveButton;
